import React from "react";
import ButtonLink from "../../../components/elements/ButtonLink";

const CourseCard2 = ({
  course,
  selectedLocation,
  cohortLoading,
  cohortData,
}) => {
  return (
    <div className="flex flex-wrap items-stretch  bg-white rounded-lg px-3 md:px-6 lg:px-8 pt-4 lg:pt-8 pb-4">
      <div className="w-7/12 md:w-5/12 h-32 md:h-44 lg:h-auto lg:w-4/12 xl:w-3/12 pb-4 px-4 lg:px-0">
        <div className="relative">
          <img
            src={course.courseImage}
            width="100%"
            alt=""
            className="object-cover object-top rounded-lg z-10 relative h-32 md:h-44 lg:h-auto"
          />

          <div className="absolute w-full -mt-2 text-xs scholarship-available-2 pt-3 pb-2 lg:pt-5 lg:pb-3 px-4 text-center rounded-b-xl">
            Scholarship available
          </div>
        </div>
      </div>
      <div className="w-full lg:w-8/12 lg:pl-14 lg:pr-8 mt-14 lg:mt-0 mb-4">
        <div className="px-4 lg:px-0">
          <div className="mt-2 mb-4 lg:mt-6 lg:mb-6 text-xs leading-5 flex flex-wrap space-x-2">
            {course.courseTags?.[0] && (
              <div className="tag-primary px-2 rounded-sm">
                <p>{course.courseTags?.[0]}</p>
              </div>
            )}

            {course.courseTags?.[1] && (
              <div className="tag-secondary px-2 rounded-sm">
                <p>{course.courseTags?.[1]}</p>
              </div>
            )}
          </div>

          <p className="mt-2 mb-4 flex items-center text-xs lg:text-sm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.3333C9.41441 13.3333 10.771 12.7713 11.7712 11.7712C12.7713 10.771 13.3333 9.41441 13.3333 7.99992C13.3333 6.58543 12.7713 5.22888 11.7712 4.22868C10.771 3.22849 9.41441 2.66659 7.99992 2.66659C6.58543 2.66659 5.22888 3.22849 4.22868 4.22868C3.22849 5.22888 2.66659 6.58543 2.66659 7.99992C2.66659 9.41441 3.22849 10.771 4.22868 11.7712C5.22888 12.7713 6.58543 13.3333 7.99992 13.3333ZM8.66659 7.99992H11.3333V9.33325H7.33325V4.66659H8.66659V7.99992Z"
                fill="#0003A9"
              />
            </svg>
            <span className="pl-2 text-primary">{course.courseDuration}</span>
          </p>

          <h4 className="text-default pb-4 lg:pb-4 font-mono text-base md:text-lg lg:text-xl xl:text-2xl font-semibold">
            {course.courseName}
          </h4>

          <p className="text-default text-sm md:text-sm lg:text-sm-15 lg:leading-7 pb-4">
            {course.courseDescription}
          </p>

          <div className="mt-3 mb-4 lg:mb-8 flex flex-col md:flex-row">
            <ButtonLink
              title={"Learn More"}
              url={`/courses${course.courseUrl}`}
              hasArrow={false}
              style={{
                paddingLeft: "1.6rem",
                paddingRight: "1.6rem",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            />
            <ButtonLink
              isExternalLink
              title={"Book a Call"}
              url={
                course?.bookCallUrl ||
                `https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1UiDnxpXuDVjFE6MHYbt4nDg7tB8-2f4wJ98R2IU2zajqPOm9CUJo57fdGSKZqPxmWbNk-wHBR`
              }
              hasArrow={false}
              withDropShadow={false}
              style={{
                paddingLeft: "1.6rem",
                paddingRight: "1.6rem",
                textAlign: "center",
                background: "#0003A9",
                display: "flex",
                justifyContent: "center",
              }}
            />

            <ButtonLink
              isExternalLink
              title={"Chat with Us"}
              url={
                selectedLocation?.name === "Africa" || !selectedLocation
                  ? "https://wa.me/message/HBDPGBXHGBR5J1"
                  : course?.chatWithUsUrl || "https://wa.me/447495380293"
              }
              hasArrow={false}
              withDropShadow={false}
              style={{
                paddingLeft: "1.6rem",
                paddingRight: "1.6rem",
                textAlign: "center",
                background: "#002AEC",
                display: "flex",
                justifyContent: "center",
              }}
            />
          </div>

          <p className=" lg:mb-10 text-primary text-xs md:text-sm lg:text-sm flex items-center">
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.18701 1.8643H11.5203C11.6751 1.8643 11.8234 1.92576 11.9328 2.03515C12.0422 2.14455 12.1037 2.29292 12.1037 2.44763V11.781C12.1037 11.9357 12.0422 12.084 11.9328 12.1934C11.8234 12.3028 11.6751 12.3643 11.5203 12.3643H1.02035C0.865635 12.3643 0.717262 12.3028 0.607866 12.1934C0.49847 12.084 0.437012 11.9357 0.437012 11.781V2.44763C0.437012 2.29292 0.49847 2.14455 0.607866 2.03515C0.717262 1.92576 0.865635 1.8643 1.02035 1.8643H3.35368V0.697632H4.52034V1.8643H8.02034V0.697632H9.18701V1.8643ZM10.937 6.53096H1.60368V11.1976H10.937V6.53096ZM8.02034 3.03097H4.52034V4.19763H3.35368V3.03097H1.60368V5.3643H10.937V3.03097H9.18701V4.19763H8.02034V3.03097ZM2.77034 7.69763H3.93701V8.8643H2.77034V7.69763ZM5.68701 7.69763H6.85368V8.8643H5.68701V7.69763ZM8.60368 7.69763H9.77034V8.8643H8.60368V7.69763Z"
                fill="#0003A9"
              />
            </svg>

            <span className="pl-3">
              Next class starts:{" "}
              <span className="font-semibold">
                {" "}
                {cohortLoading
                  ? "Loading..."
                  : cohortData?.date || "Not Specified"}
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CourseCard2;
